var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "order-tmp-caption",
        staticStyle: {
          "font-size": "15px",
          color: "#1a1a1a",
          "font-weight": "600",
          "text-align": "center",
          padding: "15px 0"
        }
      },
      [_vm._v("巡检凭单")]
    ),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "simple-tbl",
        staticStyle: {
          width: "100%",
          "table-layout": "fixed",
          "border-collapse": "collapse",
          "border-spacing": "2px",
          "border-color": "gray",
          color: "#666",
          "font-size": "12px"
        }
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          { staticClass: "body" },
          [
            _vm._l(_vm.checkWorkVoucher.detailItems, function(checkItem) {
              return _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(checkItem.seqNo))])]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(checkItem.group))])]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(checkItem.content))])]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(checkItem.demand))])]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          checkItem.markChar == "✓" ? "√" : checkItem.markChar
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px"
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(checkItem.remark))])]
                )
              ])
            }),
            _vm._v(" "),
            _vm._m(1)
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "simple-tbl",
        staticStyle: {
          width: "100%",
          "table-layout": "fixed",
          "border-collapse": "collapse",
          "border-spacing": "2px",
          "border-color": "gray",
          color: "#666",
          "font-size": "12px"
        }
      },
      [
        _c("tbody", { staticClass: "body" }, [
          _c("tr", { staticClass: "row" }, [
            _c(
              "td",
              {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              },
              [
                _c("div", { staticClass: "info-item clearfix" }, [
                  _c(
                    "div",
                    {
                      staticClass: "label",
                      staticStyle: {
                        width: "160px",
                        float: "left",
                        color: "#1a1a1a",
                        "font-weight": "600",
                        "white-space": "normal",
                        "word-break": "break-all"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.checkWorkVoucher.svcCmntLabel) +
                          "\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "value",
                      staticStyle: {
                        float: "left",
                        width: "-webkit-calc(100% - 160px)",
                        "white-space": "normal",
                        "word-break": "break-all"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.checkWorkVoucher.svcCmntValue) +
                          "\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "sign-name",
                    staticStyle: { height: "160px", "text-align": "center" }
                  },
                  [
                    _c("img", {
                      staticStyle: { height: "160px" },
                      attrs: { src: _vm.checkWorkVoucher.svcSigImgUrl }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "info-item clearfix" }, [
                  _c(
                    "div",
                    {
                      staticClass: "label",
                      staticStyle: {
                        width: "76px",
                        float: "left",
                        color: "#1a1a1a",
                        "font-weight": "600",
                        "white-space": "normal",
                        "word-break": "break-all"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.checkWorkVoucher.svcDateLabel) +
                          "\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.checkWorkVoucher.svcDateValue != null
                    ? _c(
                        "div",
                        {
                          staticClass: "value align-right",
                          staticStyle: {
                            float: "left",
                            width: "-webkit-calc(100% - 86px)",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                new Date(
                                  _vm.checkWorkVoucher.svcDateValue
                                ).format("yyyy年MM月dd日")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              },
              [
                _c("div", { staticClass: "info-item clearfix" }, [
                  _c(
                    "div",
                    {
                      staticClass: "label",
                      staticStyle: {
                        width: "160px",
                        float: "left",
                        color: "#1a1a1a",
                        "font-weight": "600",
                        "white-space": "normal",
                        "word-break": "break-all"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.checkWorkVoucher.selfCmntLabel) +
                          "\n\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "value",
                      staticStyle: {
                        float: "left",
                        width: "-webkit-calc(100% - 160px)",
                        "white-space": "normal",
                        "word-break": "break-all"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.checkWorkVoucher.selfCmntValue) +
                          "\n\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "sign-name",
                    staticStyle: { height: "160px", "text-align": "center" }
                  },
                  [
                    _c("img", {
                      staticStyle: { height: "160px" },
                      attrs: { src: _vm.checkWorkVoucher.selfSigImgUuid }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "info-item clearfix" }, [
                  _c(
                    "div",
                    {
                      staticClass: "label",
                      staticStyle: {
                        width: "76px",
                        float: "left",
                        color: "#1a1a1a",
                        "font-weight": "600",
                        "white-space": "normal",
                        "word-break": "break-all"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.checkWorkVoucher.selfStaffLabel) +
                          "\n\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.checkWorkVoucher.selfDateValue != null
                    ? _c(
                        "div",
                        {
                          staticClass: "value align-right",
                          staticStyle: {
                            float: "left",
                            width: "-webkit-calc(100% - 86px)",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                new Date(
                                  _vm.checkWorkVoucher.selfDateValue
                                ).format("yyyy年MM月dd日")
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c(
          "th",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              color: "#1a1a1a",
              "font-weight": "600"
            }
          },
          [_c("div", [_vm._v("序号")])]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              color: "#1a1a1a",
              "font-weight": "600"
            }
          },
          [_c("div", [_vm._v("分组")])]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              color: "#1a1a1a",
              "font-weight": "600"
            }
          },
          [_c("div", [_vm._v("项目（内容）")])]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              color: "#1a1a1a",
              "font-weight": "600"
            }
          },
          [_c("div", [_vm._v("基本要求")])]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              color: "#1a1a1a",
              "font-weight": "600"
            }
          },
          [_c("div", [_vm._v("结果")])]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              color: "#1a1a1a",
              "font-weight": "600"
            }
          },
          [_c("div", [_vm._v("结果说明")])]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "6" }
        },
        [_c("div", {}, [_vm._v("说明：结果正常是在对应的结果栏中打√")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51a4512c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51a4512c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/CheckWorkVoucherPdf.vue
// module id = 1872
// module chunks = 1